import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DwComponent, DwComponentType, DwControlType, DwSecurityRepositoryService, DwSecurityRepositoryServiceToken, DwSecurityUserService } from '@devwareapps/devware-cap';

@Component({
  selector: 'app-aviator-not-found',
  templateUrl: './aviator-not-found.component.html',
  styleUrls: ['./aviator-not-found.component.scss']
})
export class AviatorNotFoundComponent implements OnInit {

  isAuthenticated: boolean;

  constructor(private router: Router,
    private dwSecurityUserService: DwSecurityUserService,
    @Inject(DwSecurityRepositoryServiceToken) private dwSecurityRepositoryService: DwSecurityRepositoryService

  ) { }

  ngOnInit(): void {
    this.isAuthenticated = this.dwSecurityUserService.securityState.isAuthenticated;

    console.log('Page not found, redirecting to home page');

    if (!this.isAuthenticated) {
      this.router.navigateByUrl("/");
    } else {
      this.router.navigateByUrl("/");
    }
  }

}
